export default {
  routes: [
    {
      name: 'organizations',
      path: '/directory/organization',
      component: () => import('./views/TheOrganizations.vue'),

    },

    {
      name: 'organization',
      path: '/directory/organization/:uuid',
      component: () => import('./views/TheOrganization.vue'),
    },
  ]
}
